"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.logWarning = exports.logInfo = exports.logError = exports.logDebug = void 0;
var _browserLogs = require("@datadog/browser-logs");
const logDebug = (message, {
  messageContext,
  error
} = {}) => {
  _browserLogs.datadogLogs.logger.debug(message, messageContext, error);
};
exports.logDebug = logDebug;
const logInfo = (message, {
  messageContext,
  error
} = {}) => {
  _browserLogs.datadogLogs.logger.info(message, messageContext, error);
};
exports.logInfo = logInfo;
const logWarning = (message, {
  messageContext,
  error
} = {}) => {
  _browserLogs.datadogLogs.logger.warn(message, messageContext, error);
};
exports.logWarning = logWarning;
const logError = (message, {
  messageContext,
  error
} = {}) => {
  _browserLogs.datadogLogs.logger.error(message, messageContext, error);
};
exports.logError = logError;